module.exports = __webpack_public_path__ + "img/means_categories.2b624d86.svg";